import React from 'react'
import PropTypes from 'prop-types'
import ThreeSixtyViewer from '../../3_Organisms/360Viewer/360Viewer'
import CalloutBoxShort from '../../2_Molecules/CalloutBox/CalloutBoxShort';
import { languageController } from '../../../controllers/language/languageController';

function ConfirmationStep({
  vehicleData,
  dateAndTime,
  dealerData,
  contactDetails,
  displayPrice=true
}) {
  const { dealer: selectedDealerData, userPosition } = dealerData || {};
  const { visual } = vehicleData || {};

  // Create an array of exterior images of the model.
  const generateExteriorImages = () => {
    if (!visual) return [];

    try {
      const { interiors, exteriors, static_content_base_path } = visual;

      const defaultExteriorCode = interiors[0]?.default_exterior.code;

      if (defaultExteriorCode && exteriors[defaultExteriorCode]) {
        const threeSixtyData = exteriors[defaultExteriorCode]['360'];

        const { start_index, end_index, file_path, filename_prefix, filename_suffix } = threeSixtyData;
        let imagesArr = [];

        for (let index = start_index; index <= end_index; index++) {
          const path = static_content_base_path + file_path + filename_prefix + index + filename_suffix;
          imagesArr.push({ src: path });
        }

        return imagesArr;
      }
    } catch (err) {
      console.log(err)
    }
  }

  const generateInteriorImage = () => {
    if (!visual) return '';
    const { interiors, static_content_base_path } = visual;
    return static_content_base_path + interiors[0]?.filename;
  }

  return (
    <div className="mz-confirmation-step" style={!window.bnp_retailer_mode ? {} : {textAlign: 'center'}}>
      <div className="mz-container">
        <div className="mz-full-width">

          <div className={!window.bnp_retailer_mode ? "mz-confirmation-step__top" : ""}>
            <h4>{languageController.getCopy('confirmationStep', 'title')}, {contactDetails?.firstname}!</h4>
            {!window.bnp_retailer_mode ?
              <p>{languageController.getCopy('confirmationStep', 'subTitle')}</p>
            :
              <p><strong>{languageController.getCopy('confirmationStep', 'subTitleRetailer')}</strong></p>
            } 
          </div>

          
          <div className={!window.bnp_retailer_mode ?"mz-confirmation-step__main" : ""}>
            {!window.bnp_retailer_mode &&
              <div className="mz-confirmation-step__360">
                <ThreeSixtyViewer
                  exteriorImages={generateExteriorImages()}
                  interiorPanoramaImage={generateInteriorImage()}
                />
              </div>
            }
            <div className="mz-confirmation-step__callout">
              <CalloutBoxShort
                vehicleData={vehicleData}
                dealerData={selectedDealerData}
                userPosition={userPosition}
                dateAndTimeData={dateAndTime}
                displayPrice={displayPrice}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

ConfirmationStep.propTypes = {
  vehicleData: PropTypes.object,
  dateAndTime: PropTypes.object,
  dealerData: PropTypes.object,
  contactDetails: PropTypes.object,
}

export default ConfirmationStep